import { render, staticRenderFns } from "./ProfitReaches.vue?vue&type=template&id=37e97a5c"
import script from "./ProfitReaches.vue?vue&type=script&lang=js"
export * from "./ProfitReaches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports